import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import CheckboxToggle from '@/components/fields/CheckboxToggle';
import { DropdownSelectOption } from '@/components/fields/DropdownSelect';
import withFormControl from '@/hoc/withFormControl';

interface CheckboxGroupProps {
  options: Omit<DropdownSelectOption, 'Icon'>[];
  value?: string[];
  disabled?: boolean;
  name?: string;
}

const CheckboxGroupField = ({ options = [], value: selected, disabled, name }: CheckboxGroupProps) => {
  const form = useFormContext();
  const handleOnChange = useCallback(
    (state: boolean, value: string) => {
      if (!selected) {
        form.setValue(name!, [value], { shouldDirty: true });

        return;
      }

      const newValue = state ? [...selected, value] : selected.filter(val => val !== value);
      form.setValue(name!, newValue, { shouldDirty: true });
    },
    [form, name, selected]
  );

  return (
    <>
      {options.map(option => (
        <CheckboxToggle
          key={option.value}
          label={option.label}
          value={selected?.includes(option.value)}
          disabled={disabled}
          onChange={e => handleOnChange(e, option.value)}
        />
      ))}
    </>
  );
};

const CheckboxGroup = withFormControl<string[], string[], CheckboxGroupProps>(CheckboxGroupField);

export default CheckboxGroup;
